import { render, staticRenderFns } from "./ToView.vue?vue&type=template&id=1db99ffc&scoped=true&"
import script from "./ToView.vue?vue&type=script&lang=js&"
export * from "./ToView.vue?vue&type=script&lang=js&"
import style0 from "./ToView.vue?vue&type=style&index=0&id=1db99ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db99ffc",
  null
  
)

export default component.exports